import { render, staticRenderFns } from "./related-news.vue?vue&type=template&id=b395eae8"
import script from "./related-news.vue?vue&type=script&lang=js"
export * from "./related-news.vue?vue&type=script&lang=js"
import style0 from "./related-news.vue?vue&type=style&index=0&id=b395eae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tuo2pa5meikj7knhosl5svwizm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports